module.exports = __webpack_public_path__ + "img/7_75.213f78a6.png";